import { useState, useEffect } from 'react';
import { FilterCategoryCard } from './filter-category-card';
import { FilterCategoryCardSkeleton } from '../skeletons/filter-category.skeleton';
import { ShowMore } from '../buttons/show-more.button';

export const FilterCategories = ({ filterCategories, onCategoriesChange, isLoading = false }) => {
  const MAX_VISIBLE = 9; // 2 rows x 4 per row (adjust as needed)
  const [showAll, setShowAll] = useState(false);
  const visibleCategories = showAll ? filterCategories : filterCategories.slice(0, MAX_VISIBLE);
  const hasMore = filterCategories.length > MAX_VISIBLE;

  return (
    <div className='w-full md:w-[890px] flex flex-col'>
      <div className='flex flex-wrap gap-2 mt-5'>
        {isLoading ? (
          Array(5).fill().map((_, index) => (
            <FilterCategoryCardSkeleton key={index} />
          ))
        ) : (
          visibleCategories.map(category => (
            <FilterCategoryCard
              key={category.id}
              category={category}
              isSelected={category.checked}
              onToggle={() => onCategoriesChange(category)}
            />
          ))
        )}
      </div>
      {!isLoading && hasMore && (
      <div className={'flex justify-center'}>
      <ShowMore showMore={showAll} onClick={() => setShowAll(v => !v)} />
      </div>)
      }
    </div>
  );
};